"use strict";
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.ContentType = void 0;
const axios_1 = __importDefault(require("axios"));
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["JsonApi"] = "application/vnd.api+json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (exports.ContentType = ContentType = {}));
class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios_1.default.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method &&
                    this.instance.defaults.headers[method.toLowerCase()]) ||
                    {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        if (input instanceof FormData) {
            return input;
        }
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData &&
            body &&
            body !== null &&
            typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.Text &&
            body &&
            body !== null &&
            typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
exports.HttpClient = HttpClient;
/**
 * @title Staking API
 * @version 2.0.0
 * @contact Blockdaemon <info@blockdaemon.com> (https://blockdaemon.com)
 *
 * The Blockdaemon Staking API simplifies and streamlines institutional cryptocurrency staking. The API allows developers to interact with blockchain networks and perform various staking-related operations, such as delegating and undelegating tokens, in a single, unified interface.
 *
 * With the Staking API, you can quickly and easily build and deploy applications that automate staking activities and increase efficiency in your blockchain operations.
 */
class Api extends HttpClient {
    health = {
        /**
     * @description Returns server health status
     *
     * @tags Server
     * @name HealthCheck
     * @summary Check Server Health
     * @request GET:/sia/health
     * @secure
     * @response `200` `HealthCheck` Server is healthy
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `500` `Error`
     */
        healthCheck: (params = {}) => this.request({
            path: `/sia/health`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    v2 = {
        /**
     * @description Returns an unsigned transaction to deactivate SOL from an active stake account
     *
     * @tags Solana
     * @name BuildDeactivateTransaction
     * @summary Post Deactivation Intent
     * @request POST:/sia/v2/solana/{network}/deactivate-intent
     * @secure
     * @response `200` `SolanaDeactivateTransactionResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `500` `Error`
     */
        buildDeactivateTransaction: (network, data, params = {}) => this.request({
            path: `/sia/v2/solana/${network}/deactivate-intent`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * @description Get the Blockdaemon nonce account associated provided delegator_address
     *
     * @tags Solana
     * @name GetNonceAccount
     * @summary Get the Blockdaemon nonce account
     * @request GET:/sia/v2/solana/{network}/nonce-account/{delegator_address}
     * @secure
     * @response `200` `SolanaGetNonceAccountResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `404` `Error`
     * @response `500` `Error`
     */
        getNonceAccount: (network, delegatorAddress, params = {}) => this.request({
            path: `/sia/v2/solana/${network}/nonce-account/${delegatorAddress}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
     * @description Returns an unsigned transaction transaction that can be used to split to divide an existing stake account into two separate accounts, each holding a specified portion of the original stake’s SOL.
     *
     * @tags Solana
     * @name BuildSplitTransaction
     * @summary Post Split Intent
     * @request POST:/sia/v2/solana/{network}/split-intent
     * @secure
     * @response `200` `SolanaSplitTransactionResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `500` `Error`
     */
        buildSplitTransaction: (network, data, params = {}) => this.request({
            path: `/sia/v2/solana/${network}/split-intent`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * @description Returns a unsigned transaction to stake SOL to a newly created stake account
     *
     * @tags Solana
     * @name BuildStakeTransaction
     * @summary Post Stake Intent
     * @request POST:/sia/v2/solana/{network}/stake-intent
     * @secure
     * @response `200` `SolanaStakeTransactionResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `500` `Error`
     */
        buildStakeTransaction: (network, data, params = {}) => this.request({
            path: `/sia/v2/solana/${network}/stake-intent`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * @description Get the status of Solana stakes by payer address
     *
     * @tags Solana
     * @name GetStakes
     * @summary Get Solana Stake Accounts
     * @request GET:/sia/v2/solana/{network}/stakes
     * @secure
     * @response `200` `SolanaGetStakesResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `404` `Error`
     * @response `500` `Error`
     */
        getStakes: (network, query, params = {}) => this.request({
            path: `/sia/v2/solana/${network}/stakes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
     * @description Get the status of Solana stakes by stake account addresses
     *
     * @tags Solana
     * @name GetStakesByAccounts
     * @summary Post Solana Stake Accounts
     * @request POST:/sia/v2/solana/{network}/stakes/by-accounts
     * @secure
     * @response `200` `SolanaGetStakesResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `500` `Error`
     */
        getStakesByAccounts: (network, data, params = {}) => this.request({
            path: `/sia/v2/solana/${network}/stakes/by-accounts`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * @description Returns an unsigned transaction to withdraw a specified amount of SOL from an deactivated stake account
     *
     * @tags Solana
     * @name BuildWithdrawTransaction
     * @summary Post Withdrawal Intent
     * @request POST:/sia/v2/solana/{network}/withdrawal-intent
     * @secure
     * @response `200` `SolanaWithdrawTransactionResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `500` `Error`
     */
        buildWithdrawTransaction: (network, data, params = {}) => this.request({
            path: `/sia/v2/solana/${network}/withdrawal-intent`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
     * @description Issues an exit validator request notification to Blockdaemon
     *
     * @tags TON
     * @name CreateNotification
     * @summary Create Notification
     * @request POST:/sia/v2/ton/{network}/notify
     * @secure
     * @response `200` `TonCreateNotificationResponse` OK
     * @response `400` `{
      \**
       * Error code
       * @format int32
       * @example 400
       *\
        code: number,
      \**
       * Error Message
       * @example "Detailed human-readable diagnostic message regarding any invalid request parameters"
       *\
        message: string,
    
    }`
     * @response `401` `UnauthorizedError`
     * @response `500` `Error`
     */
        createNotification: (network, data, params = {}) => this.request({
            path: `/sia/v2/ton/${network}/notify`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
}
exports.Api = Api;
//# sourceMappingURL=client.js.map